<template>
  <b-form-group
    class="mb-0 no-delimiter"
    :label-cols="labelCols"
    :label-cols-sm="labelColsSm"
    :label-class="labelClass"
  >
    <template slot="label">
      <div>
        {{ label }}
        <base-help-icon :help-description="helpDescription" />
      </div>
    </template>
    <p v-if="!html" :class="valueClass">
      <slot>{{ value }}</slot>
    </p>
    <div v-else :class="valueClass" v-html="renderHtmlData(html)"></div>
  </b-form-group>
</template>

<script>
import { BaseHelpIcon } from "./";
export default {
  components: { BaseHelpIcon },
  props: {
    /**
     * Form field name shown left to the form input.
     * If not specified, no text will be shown.
     */
    label: {
      type: String,
      default: null,
      required: true,
    },
    /**
     * `<b-form-group />` property.
     * Defines width of label columns size.
     * Can be set to '0' to make form field full width.
     */
    labelCols: {
      type: String,
      default: "12",
    },
    /**
     * `<b-form-group />` property.
     * Defines width of label columns starting from `sm` size.
     * Can be set to '0' to make form field full width.
     */
    labelColsSm: {
      type: String,
      default: "6",
    },
    /**
     * `<b-form-group />` property.
     * Defines css class added to field label.
     */
    labelClass: {
      type: String,
      default: "font-weight-bold",
    },
    /**
     * Value to be displayed.
     */
    value: null,
    /**
     * Text to show in the inform icon.
     */
    helpDescription: {
      type: String,
      default: null,
    },
    /**
     * Defines css class added to field value.
     */
    valueClass: {
      type: String,
      default: "form-control-plaintext",
    },
    /**
     * Html that should be displayed.
     */
    html: {
      type: String,
      default: null,
    },
  },
  methods: {
    renderHtmlData(data) {
      return data ? data : "-";
    },
  },
};
</script>